import auth from "@/middleware/auth";

export default [
    {
        path: "resumoAcordoCdc",
        name: "resumoAcordoCdc",
        meta: { middleware: [auth] },
        component: () => import("./ResumoAcordoCdc")
    }
];
